module.exports = __webpack_public_path__ + "img/23.a171810f.jpg";